import { render, staticRenderFns } from "./create-client-modal.vue?vue&type=template&id=2dd42c97"
import script from "./create-client-modal.vue?vue&type=script&lang=js"
export * from "./create-client-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports